import React, { Component } from 'react';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';
import style from './breadcrumb.scss';

@CSSModules(style)
export default class Breadcrumb extends Component {
  render() {
    const { routes = [], id } = this.props;

    return (
      <ul styleName="root" id={id || 'breadcrumb'}>
        {routes.map((route, index) => (
          <li key={index}>
            {route.to ? (
              <Link to={route.to}>{route.label}</Link>
            ) : route.label}
          </li>
        ))}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/breadcrumb.js